import { useEffect, useRef, useState } from "react";
import { Autocomplete, TextField, CircularProgress, AutocompleteProps } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchGroupeBienDataByName, clearGroupBienData } from "../../reduxStore/GroupeBienSlice";
import { RootState, AppDispatch } from '../../reduxStore/Store';
import { fromEvent } from "rxjs";
import { debounceTime, switchMap } from "rxjs/operators";
import { GroupeBien } from "../../models/models";

interface GroupeBienAutoCProps
extends Partial<AutocompleteProps<GroupeBien, false, false, false>>  {
  onGroupeBienChange: (groupeBien: GroupeBien | null) => void;
  selectedGroupeBien?: GroupeBien | null;
}

const limit = 10; 
const offset = 0; 

const GroupeBienAutoC: React.FC<GroupeBienAutoCProps> = ({ onGroupeBienChange, selectedGroupeBien ,...autocompleteProps}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { groupeBienData, loading } = useSelector((state: RootState) => state.GropueBienSlice);
  const [groupeBien, setGroupeBien] = useState<GroupeBien | null>(null);
  
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (selectedGroupeBien) {
      setGroupeBien(selectedGroupeBien);
    }
  }, [selectedGroupeBien]);

  useEffect(() => {
    if (inputRef.current) {
      const subscription = fromEvent(inputRef.current, "input")
        .pipe(
          debounceTime(500),
          switchMap((event: any) => {
            const nom = event.target.value.trim();
            if (nom.length > 2) {
              dispatch(fetchGroupeBienDataByName({ nom, limit, offset }));
            }
            return [];
          })
        )
        .subscribe();

      return () => {
        subscription.unsubscribe();
      };
    }
  }, [dispatch]);

  const handleChange = (_: any, newValue: GroupeBien | null) => {
    setGroupeBien(newValue);
    onGroupeBienChange(newValue);
  };

  return (
    <Autocomplete
      options={groupeBienData}
      value={groupeBien} 
      getOptionLabel={(option: GroupeBien) => option.nom}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      loading={loading}
      onChange={handleChange}
      onBlur={() => dispatch(clearGroupBienData())} 
      {...autocompleteProps}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={inputRef} 
          label="Groupe de bien"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          size="small"
        />
      )}
    />
  );
};

export default GroupeBienAutoC;
